var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalSideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F1F1F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9F9F9",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 26.5C18.25 21.1152 22.6152 16.75 28 16.75C33.3848 16.75 37.75 21.1152 37.75 26.5C37.75 31.8848 33.3848 36.25 28 36.25C22.6152 36.25 18.25 31.8848 18.25 26.5ZM24.25 24.0625C24.25 23.3376 24.8376 22.75 25.5625 22.75H30.4375C31.1624 22.75 31.75 23.3376 31.75 24.0625V28.9375C31.75 29.6624 31.1624 30.25 30.4375 30.25H25.5625C24.8376 30.25 24.25 29.6624 24.25 28.9375V24.0625Z",
    fill: "#ED6E33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSideIcon);
export default __webpack_public_path__ + "static/media/modalSideIcon.fa9604f44ac4bf1de5e0c67c80f55327.svg";
export { ForwardRef as ReactComponent };